// extracted by mini-css-extract-plugin
export default {"content":"y3Q93BGXdlesuNpIDb_d","header":"ruqDcuxaXmw53LLMTYz4","text":"va6XPUqsbmK3VlWuG8HU","controls":"qbb2sRMvX_VGb1zzazZ8","placeHolderShimmer":"JYg6pw4rVAYD0PQhToFe"};